module.exports = __webpack_public_path__ + "static/media/5@720w.2e61e988.jpg";